import styled from 'styled-components';
export const FilterChipsContainer = styled.div `
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  ${({ gap }) => `margin: calc(-1 * ${gap}px) 0 0 calc(-1 * ${gap}px);`}
  > * {
    ${({ gap }) => `margin: ${gap}px 0 0 ${gap}px;`}
  }
  > div {
    ${({ isStrechedWidth }) => (isStrechedWidth ? 'flex: 1 0 100%' : '')};
  }
`;
